import { get } from 'lodash'

import type {
	EnergyFormValues,
	RawMaterialPackagingFormValues,
	TransportFormValues,
} from '../Calculator'
import type { FieldConfig } from './config'
import type { Data } from './transform'

function createOptions({
	optionsdata,
	formdata,
	path,
	topLevelKeys,
}: {
	optionsdata: Data
	formdata: RawMaterialPackagingFormValues &
		EnergyFormValues &
		TransportFormValues
	path?: FieldConfig['options']
	topLevelKeys?: FieldConfig['topLevelKeys']
}): readonly string[] {
	if (path?.length === 0) {
		if (topLevelKeys) {
			return topLevelKeys.filter(key => key in optionsdata)
		}
		return Object.keys(optionsdata).filter(
			key =>
				key !== 'Electricity' && key !== 'Heat / steam' && key !== 'Transport'
		)
	}

	const transformedpath = path?.map(key =>
		formdata ? formdata[key as FieldConfig['fieldName']] : ''
	) as readonly string[]

	return Object.keys(get(optionsdata, transformedpath, []))
}

export { createOptions }
